/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * A reason on why the deployment cannot be placed
 */
export enum DeploymentQueuedReason {
	UNKNOWN = "unknown",
	LOCATION_OVERPROVISIONED = "location_overprovisioned",
}
